import { render, staticRenderFns } from "./BaseTableRow.vue?vue&type=template&id=5b494437&scoped=true&"
import script from "./BaseTableRow.vue?vue&type=script&lang=js&"
export * from "./BaseTableRow.vue?vue&type=script&lang=js&"
import style0 from "./BaseTableRow.vue?vue&type=style&index=0&id=5b494437&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b494437",
  null
  
)

export default component.exports